import { IDurationState } from '../../../../reducers/v2';
import type { IPromotionDuration } from '../../../../repositories/billing-tariffs/entities/PublishTerms/PromotionDuration';

export const mapDurations = (rawDurations: IPromotionDuration[]): IDurationState => {
  let defaultDuration = 1;

  if (!rawDurations.length) {
    return {
      defaultDuration,
      durations: [],
    };
  }

  const durations = rawDurations.map(duration => {
    if (duration.isSelected) {
      defaultDuration = duration.durationInDays;
    }

    return {
      durationInDays: duration.durationInDays,
      discountPercent: duration.discountPercent,
      selected: duration.isSelected,
      isPromoDiscount: duration.isPromoDiscount,
    };
  });

  return {
    defaultDuration,
    durations,
  };
};
